import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/project-support-new';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }
}
